if (!customElements.get('drawer-close')) {
  class DrawerClose extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.target = this.closest('custom-drawer');

      if (!this.target) return;

      this.addEventListener('click', () => {
        this.target.toggle();
      });
    }
  }
  customElements.define('drawer-close', DrawerClose);
}
